import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { Store } from '@ngrx/store';
import { filter, take } from 'rxjs/operators';
import { State } from '../../State';
import { getContractStatusFetched } from '../../State/selectors/mdqx/selectors';
import { GetContractStatusRequest } from '../../State/actions/mdqx/contract-status.actions';
@Injectable({
    providedIn: 'root',
})
export class ContractStatusResolver implements Resolve<boolean> {
    constructor(private store: Store<State>) {}

    resolve() {
        const value$ = this.store.select(getContractStatusFetched);

        value$
            .pipe(take(1))
            .subscribe(
                fetched =>
                    !fetched &&
                    localStorage.getItem('token') != null &&
                    this.store.dispatch(new GetContractStatusRequest()),
            );

        return value$.pipe(
            filter(v => v),
            take(1),
        );
    }
}
